// start:ng42.barrel
export * from './checkbox.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/checkbox/index.ts